export const environment = {
  production: true,
  mobileContentApiUrl: 'https://mobile-content-api.cru.org',
  mobileContentApiWsUrl: 'wss://mobile-content-api.cru.org/cable'
};
